import { type IntlShape } from "react-intl";
import { z } from "zod";

import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";
import {
	type Classification,
	type ClassificationConfiguration,
	classificationConfigurationSchema,
	classificationSchema,
	type ClassificationStatus,
	classificationStatusSchema,
} from "@/schemas/classification";

// Re-export types for backward compatibility (remove later)
export type { Classification, ClassificationStatus } from "@/schemas/classification";

const classificationsSchema = (intl: IntlShape) => z.array(classificationSchema(intl));

export async function getClassifications(intl: IntlShape): Promise<Classification[]> {
	const response = await packNetAxios.get(`${baseRoutes.selection}/v2/Classifications`);

	return classificationsSchema(intl).parseWithTelemetry(response.data);
}

export function deleteClassification(id: string): Promise<void> {
	return packNetAxios.delete(`${baseRoutes.selection}/v2/Classifications/${id}`);
}

export function createClassification(
	classificationConfiguration: ClassificationConfiguration,
	intl: IntlShape,
): Promise<void> {
	return packNetAxios.post(
		`${baseRoutes.selection}/v2/Classifications`,
		classificationConfigurationSchema(intl).parseWithTelemetry(classificationConfiguration),
	);
}

export function updateClassificationConfiguration(
	classificationId: string,
	classificationConfiguration: ClassificationConfiguration,
	intl: IntlShape,
): Promise<void> {
	return packNetAxios.patch(
		`${baseRoutes.selection}/v2/Classifications/${classificationId}`,
		classificationConfigurationSchema(intl).parseWithTelemetry(classificationConfiguration),
	);
}

export function updateClassificationStatus(
	classificationId: string,
	status: ClassificationStatus,
	intl: IntlShape,
): Promise<void> {
	return packNetAxios.patch(`${baseRoutes.selection}/v2/Classifications/${classificationId}/status`, {
		status: classificationStatusSchema(intl).parseWithTelemetry(status),
	});
}
